module.exports = {
  en: {
    title: "Please accept our updated documents",
    logout: "Log out",
    documents: "Updated documents",
    agreement: "I have read and agree to the updates above.",
    description:
      "We have updated the documents below. To continue using Track ID, please review them and give your consent.",
    agreeButton: "Agree and continue",
    notAgreePrefix: "",
    notAgreeSuffix: "without agreeing"
  },
  ja: {
    title: "同意文書の改定に伴う再同意のお願い",
    logout: "ログアウト",
    documents: "改定された文書",
    agreement: "上記の改定内容を確認し、同意する。",
    description:
      "下記の文書を改定しました。引き続きTrack IDをご利用いただくため、内容をご確認のうえ同意をお願いします。",
    agreeButton: "同意して続ける",
    notAgreePrefix: "同意せずに",
    notAgreeSuffix: "する"
  }
};
